import { useState } from "react";
import InsumosCategorias from "./insumos/InsumosCategorias";
import InsumosManager from "./insumos/InsumosManager";
import ProveedoresManager from "./insumos/ProveedoresManager";
import ComprasInsumos from "./insumos/ComprasInsumos";
import HistorialComprasInsumos from "./insumos/HistorialComprasInsumos";
import ReportesInsumos from "./insumos/ReportesInsumos";
import "./InformesCaja.css";

const TABS = [
  { id: "categorias", label: "Categorías" },
  { id: "insumos", label: "Insumos" },
  { id: "proveedores", label: "Proveedores" },
  { id: "compras", label: "Nueva compra" },
  { id: "historial", label: "Historial compras" },
  { id: "reportes", label: "Reportes" },
];

export default function Insumos() {
  const [tab, setTab] = useState("insumos");

  return (
    <div style={{ padding: "0 4px" }}>
      <header style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: "1.5rem" }}>Módulo Insumos</h1>
        <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: "0.9rem" }}>
          Control de insumos, proveedores y compras. No integrado con caja.
        </p>
      </header>
      <div className="inf-tabs" style={{ marginBottom: 20 }}>
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={tab === t.id ? "inf-tab active" : "inf-tab"}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "categorias" && <InsumosCategorias />}
      {tab === "insumos" && <InsumosManager />}
      {tab === "proveedores" && <ProveedoresManager />}
      {tab === "compras" && <ComprasInsumos />}
      {tab === "historial" && <HistorialComprasInsumos />}
      {tab === "reportes" && <ReportesInsumos />}
    </div>
  );
}
